import * as React from 'react';
import { useIntl } from 'react-intl';
import Img404 from '../../assets/404.png';
import { JRCStyledHref } from '../JRCHref/JRCHref';
import { JRCEmptySpace } from '../JRCEmptySpace/JRCEmptySpace';

export const JRC404 = () => {
    const intl = useIntl();

    return (
        <JRCEmptySpace
            img={Img404}
            title="ERROR404_Msg"
            description="ERROR404_MsgDetail"
            actions={
                <JRCStyledHref href={'/'} color="primary" as={'button'}>
                    {intl.formatMessage({ id: 'ERROR404_Wall' })}
                </JRCStyledHref>
            }
        />
    );
};
